import SectionHeading from "./SectionHeading";
import { fakeRows } from "./data";

export default function FakeWarning() {
  return (
    <section id="fake" className="scroll-mt-24 border-y border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          eyebrow="防伪识别 · 逐一对照"
          title="一眼分清：正版与仿冒的区别"
          desc="仿冒站点常利用近似域名或相似排版诱导访问。对照下表逐项核验，只要任一项不符，即可判定为仿冒，请立即退出。"
        />

        <div className="mt-8 overflow-hidden rounded-lg border border-background-200 bg-background-50 md:mt-10">
          {/* 表头 */}
          <div className="grid grid-cols-1 gap-3 border-b border-background-200 bg-background-100/70 p-4 sm:grid-cols-3 md:px-6">
            <p className="text-xs font-semibold tracking-wide text-secondary-500 md:text-sm">核对项</p>
            <p className="flex items-center gap-1.5 text-xs font-semibold text-primary-600 md:text-sm">
              <i className="ri-checkbox-circle-fill"></i> 正版官网
            </p>
            <p className="flex items-center gap-1.5 text-xs font-semibold text-foreground-600 md:text-sm">
              <i className="ri-error-warning-fill text-accent-600"></i> 仿冒站点
            </p>
          </div>
          {fakeRows.map((row) => (
            <div
              key={row.field}
              className="grid grid-cols-1 gap-3 border-b border-background-100 px-4 py-4 last:border-0 sm:grid-cols-3 md:px-6"
            >
              <p className="font-display text-sm font-semibold text-foreground-950 md:text-base">{row.field}</p>
              <p className="flex items-start gap-2 text-xs leading-relaxed text-foreground-700 md:text-sm">
                <i className="ri-checkbox-circle-line mt-0.5 shrink-0 text-primary-500"></i>
                {row.real}
              </p>
              <p className="flex items-start gap-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
                <i className="ri-close-circle-line mt-0.5 shrink-0 text-accent-600"></i>
                {row.fake}
              </p>
            </div>
          ))}
        </div>

        <p className="mt-4 flex items-center gap-2 text-xs text-foreground-500 md:text-sm">
          <i className="ri-information-line"></i>
          一旦发现自己可能误入仿冒站点，请立刻返回本页，从「直达官方地址」重新进入正版入口。
        </p>
      </div>
    </section>
  );
}